// ═══════════════════════════════════════════════════════════════════════════
// js/floorplans.js — ОБЩИЙ компонент «планировки по типам» (план jk-card-accuracy,
// фаза J, блок J6 — DRY-вынос). Источник одной правды для ДВУХ страниц:
//   • jk.php   (карточка ЖК, секция «Квартиры») — js/jk.js → renderFloorplans()
//   • flats.php (каталог квартир, при выбранном ЖК ?building_id) — js/flats.js
// Обе страницы дёргают ОДИН набор данных floorplans_by_type (бэк: RoomTypeFloorplans)
// и рисуют ОДИН UI: 4 карточки-типа с чертежами → модалка вариаций (свёрнутый
// аккордеон этажей + зум чертежа + ссылка на flat.php?id). НЕ копипаст — единый код.
//
// API: window.BroniFloorplans.render(container, types) → отрисовать карточки-типы
//      в container (HTMLElement); types = массив floorplans_by_type. Возвращает
//      true если есть типы (что-то отрисовано), иначе false. Модалка/зум/делегаты —
//      глобальные синглтоны, ставятся один раз при загрузке модуля.
//
// CSS: css/floorplans.css (подключается на обеих страницах).
// ═══════════════════════════════════════════════════════════════════════════
(() => {
  'use strict';

  // SEC: escHtml для защиты от XSS (общий хелпер из utils.js; фолбэк — textContent).
  const esc = window.escHtml || ((s) => {
    if (s == null) return '';
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  });

  // ── ФОРМАТТЕРЫ (самодостаточны: модуль не зависит от хелперов страницы) ──

  // Площадь: целое без дробной части, иначе 1 знак (26 / 27.8).
  function fmtArea(n) {
    return (Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/, '');
  }

  // Полная цена: «4,45 млн ₽» / «1 234 567 ₽».
  function fmt(n) {
    return n >= 1e6
      ? (n / 1e6).toFixed(n >= 1e7 ? 1 : 2).replace('.', ',') + ' млн ₽'
      : n.toLocaleString('ru') + ' ₽';
  }

  // Короткая цена: «4.5 млн ₽» / «12 тыс ₽».
  function fmtShort(n) {
    if (n >= 1000000) return (n / 1000000).toFixed(1).replace('.0', '') + ' млн ₽';
    if (n >= 1000) return Math.round(n / 1000) + ' тыс ₽';
    return n + ' ₽';
  }

  // Диапазон цены планировки: «5.5–6.3 млн ₽» (общий суффикс не дублируется),
  // одинаковые края → одно значение, нет цены → «—».
  function fmtPriceRange(min, max) {
    if (!(min > 0)) return '—';
    if (!(max > 0) || max === min) return fmtShort(min);
    if (min >= 1000000 && max >= 1000000) {
      var a = (min / 1000000).toFixed(1).replace('.0', '');
      var b = (max / 1000000).toFixed(1).replace('.0', '');
      return a + '–' + b + ' млн ₽';
    }
    return fmtShort(min) + '–' + fmtShort(max);
  }

  // Русское склонение по числу.
  function pluralize(n, one, few, many) {
    var abs = Math.abs(n) % 100;
    var last = abs % 10;
    if (abs > 10 && abs < 20) return many;
    if (last > 1 && last < 5) return few;
    if (last === 1) return one;
    return many;
  }

  // URL чертежа: только абсолютный http(s) (profitbase png). Иначе → плейсхолдер
  // (защита от javascript:/data:/relative-инъекций из фид-данных).
  function safePlanUrl(u) {
    u = String(u == null ? '' : u).trim();
    return /^https?:\/\//i.test(u) ? u : '';
  }

  // СТЕНД: чертежи приходят адресами застройщиков (profitbase и родня) и грузятся
  // при показе карточек типов — то есть локальная копия сайта шла бы за ними в
  // интернет (находка 26). Уводим общей стендовой калиткой (js/utils.js); своего
  // уменьшителя не заводим — вторая копия правила и есть находка 30.
  // На проде калитка возвращает адрес КАК ЕСТЬ: разметка дословно прежняя.
  var standSrc = function(u, w) { return window.standSrc ? window.standSrc(u, w) : u; };

  // Битый <img> → плейсхолдер-иконка (без inline onerror — CSP). once-listener.
  function attachImgFallback(root) {
    var imgs = root.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function(img) {
      img.addEventListener('error', function() {
        var holder = img.parentNode;
        if (!holder) return;
        img.remove();
        holder.classList.add('jk-type-card__thumb--empty', 'jk-plan-var__chart--empty');
        var ic = document.createElement('i');
        ic.className = 'fas fa-drafting-compass';
        ic.setAttribute('aria-hidden', 'true');
        holder.appendChild(ic);
      }, { once: true });
    });
  }

  // ── ТЕКУЩИЕ ТИПЫ (одного ЖК) — модалка ищет тип по комнатности здесь ──
  var currentTypes = [];

  // jk.php неблокирующий режим панели квартиры: флаг ставит jk.php inline-скриптом
  // (window.BRONI_FLAT_OVERLAY_INLINE = true). На flats.php флаг не задан → клик по
  // строке НЕ перехватывается (навигация на flat.php как прежде — поведение каталога
  // не меняется). Читается при КЛИКЕ, не при загрузке.
  function overlayInline() { return window.BRONI_FLAT_OVERLAY_INLINE === true && !!window.openFlatOverlay; }

  // Подсветка активной строки: какая квартира сейчас показана в панели справа.
  function setActiveFloorRow(row) {
    var prev = document.querySelectorAll('.jk-floor-row--link.flat-row-active');
    Array.prototype.forEach.call(prev, function(r) { r.classList.remove('flat-row-active'); });
    if (row) row.classList.add('flat-row-active');
  }

  // Панель flat-overlay закрылась (крестик/Esc/автозакрытие) → снять подсветку.
  document.addEventListener('bronidom:flat-overlay-close', function() { setActiveFloorRow(null); });

  // ═══ КАРТОЧКИ-ТИПЫ (4 карточки по типам комнатности с чертежами) ═══
  function renderTypeCards(container, types) {
    if (!container || !Array.isArray(types) || !types.length) return false;

    var grid = document.createElement('div');
    grid.className = 'jk-type-grid';

    types.forEach(function(t) {
      var room = Number(t.room) || 0;
      var label = String(t.label || (room === 0 ? 'Студия' : room + '-комн'));
      var plansCount = Number(t.plans_count) || 0;
      var areaFrom = Number(t.area_from) || 0;
      var priceFrom = Number(t.price_from) || 0;

      // 6.1d: скидка типа — зачёркнутая «от» + бейдж «до −N%». discount_max_pct
      // приходит с бэка уже с порогом/floor (SSOT FlatDiscount) — рисуем, если >0.
      var discPct = Number(t.discount_max_pct) || 0;
      var priceOldFrom = Number(t.price_old_from) || 0;

      // Сегменты меты: числовые/текстовые экранируем, ценовой сегмент несёт наш
      // безопасный HTML (зачёркивание + бейдж; discPct — число, priceOldFrom — число).
      var segs = [esc(plansCount + ' ' + pluralize(plansCount, 'планировка', 'планировки', 'планировок'))];
      if (areaFrom > 0) segs.push(esc('от ' + fmtArea(areaFrom) + ' м\xb2'));
      if (priceFrom > 0) {
        var oldSeg = (discPct > 0 && priceOldFrom > priceFrom)
          ? '<span class="jk-type-card__price-old">' + esc(fmtShort(priceOldFrom)) + '</span> '
          : '';
        var badgeSeg = discPct > 0
          ? ' <span class="jk-type-card__discount">до −' + discPct + '%</span>'
          : '';
        segs.push(oldSeg + 'от ' + esc(fmtShort(priceFrom)) + badgeSeg);
      }
      var metaHtml = segs.join(' \xb7 ');

      var url = safePlanUrl(t.representative_layout_url);

      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'jk-type-card';
      card.dataset.room = String(room);
      card.setAttribute('aria-haspopup', 'dialog');
      card.innerHTML =
        '<span class="jk-type-card__thumb' + (url ? '' : ' jk-type-card__thumb--empty') + '" data-room="' + esc(room === 0 ? 'studio' : 'r' + Math.min(5, room)) + '">' +
          (url
            ? '<img src="' + esc(standSrc(url, 640)) + '" alt="' + esc('Планировка ' + label) + '" loading="lazy" decoding="async">'
            : '<i class="fas fa-drafting-compass" aria-hidden="true"></i>') +
        '</span>' +
        '<span class="jk-type-card__info">' +
          '<span class="jk-type-card__label">' + esc(label) + '</span>' +
          '<span class="jk-type-card__meta">' + metaHtml + '</span>' +
          '<span class="jk-type-card__cta">Смотреть планировки <i class="fas fa-arrow-right" aria-hidden="true"></i></span>' +
        '</span>';
      grid.appendChild(card);
    });

    container.textContent = '';
    container.appendChild(grid);
    attachImgFallback(grid);
    return true;
  }

  // ═══ МОДАЛКА вариаций одного типа комнатности ═══
  var planModal = null;
  var planModalLastFocus = null;

  function buildPlanModal() {
    if (planModal) return planModal;
    var m = document.createElement('div');
    m.className = 'jk-modal';
    m.id = 'jkPlanModal';
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.setAttribute('aria-labelledby', 'jkPlanModalTitle');
    m.hidden = true;
    m.innerHTML =
      '<div class="jk-modal__backdrop" data-close></div>' +
      '<div class="jk-modal__panel" role="document">' +
        '<div class="jk-modal__head">' +
          '<h3 class="jk-modal__title" id="jkPlanModalTitle"></h3>' +
          '<button class="jk-modal__close" type="button" data-close aria-label="Закрыть">' +
            '<i class="fas fa-times" aria-hidden="true"></i></button>' +
        '</div>' +
        '<div class="jk-modal__body" id="jkPlanModalBody"></div>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function(e) {
      if (e.target.closest('[data-close]')) closePlanModal();
    });
    planModal = m;
    return m;
  }

  function findTypeByRoom(room) {
    if (!Array.isArray(currentTypes)) return null;
    for (var i = 0; i < currentTypes.length; i++) {
      if ((Number(currentTypes[i].room) || 0) === room) return currentTypes[i];
    }
    return null;
  }

  // Список этажей одной планировки (этаж · площадь · цена · корпус+статус сдачи · статус).
  // Строка квартиры = ссылка на flat.php?id=N (вся строка кликабельна). Корпус несёт
  // статус сдачи ЭТОГО корпуса (бэк: section_name/state/text из sections_json).
  function floorListHtml(floors) {
    var html = '<div class="jk-floor-list"><div class="jk-floor-list__head">' +
      '<span>Этаж</span><span>Площадь</span><span>Цена</span><span>Корпус</span><span>Статус</span></div>';
    floors.forEach(function(fl) {
      var fNum = Number(fl.floor) || 0;
      var ar = Number(fl.area) || 0;
      var pr = Number(fl.price) || 0;
      // 6.1d: скидка по строке квартиры (зачёркнутая старая цена + −N%). discount_pct
      // с бэка уже с порогом/floor. Вложено В ОДНУ ячейку .jk-floor-row__price —
      // грид-разметка (5 колонок) не ломается.
      var prOld = Number(fl.price_old) || 0;
      var disc = Number(fl.discount_pct) || 0;
      var hasDisc = disc > 0 && prOld > pr;
      var priceInner = hasDisc
        ? '<span class="jk-floor-row__price-old">' + esc(fmt(prOld)) + '</span>' +
          (pr > 0 ? esc(fmt(pr)) : '—') +
          '<span class="jk-floor-row__discount">−' + disc + '%</span>'
        : (pr > 0 ? esc(fmt(pr)) : '—');
      var sec = (fl.section == null ? '' : String(fl.section)).trim();
      var secName = (fl.section_name == null ? '' : String(fl.section_name)).trim();
      if (!secName && sec && sec !== '—') secName = 'Корпус ' + sec;
      var secText = (fl.section_text == null ? '' : String(fl.section_text)).trim();
      var secState = (fl.section_state == null ? '' : String(fl.section_state)).trim();
      var corpusHtml;
      if (secName) {
        var stCls = /^(done|building|partial)$/.test(secState) ? secState : 'building';
        corpusHtml = '<span class="jk-floor-row__corpus-name">' + esc(secName) + '</span>' +
          (secText ? '<span class="jk-floor-row__corpus-status jk-floor-row__corpus-status--' + stCls + '">' + esc(secText) + '</span>' : '');
      } else {
        corpusHtml = '—';
      }
      var st = String(fl.status || '').toLowerCase();
      var taken = /sold|продан|reserv|брон|booked|hold/.test(st);
      // N5 lifecycle: reserved = «Забронирована» (решение владельца 02.07).
      var stLabel = !taken ? 'Свободна' : (/sold|продан/.test(st) ? 'Продана' : 'Забронирована');
      var fid = parseInt(fl.flat_id, 10) || 0;
      var tag = fid > 0 ? 'a' : 'div';
      // href остаётся всегда (Ctrl/средняя кнопка/SEO). data-flat-id — хук перехвата
      // клика на jk.php (панель flat-overlay вместо перехода). Обычный клик на flats.php
      // не перехватывается → навигация как прежде.
      var attrs = fid > 0 ? ' href="/flat.php?id=' + fid + '" data-flat-id="' + fid + '"' : '';
      html +=
        '<' + tag + ' class="jk-floor-row' + (fid > 0 ? ' jk-floor-row--link' : '') + '"' + attrs + '>' +
          '<span class="jk-floor-row__floor">' + (fNum > 0 ? fNum + ' эт.' : '—') + '</span>' +
          '<span class="jk-floor-row__area">' + (ar > 0 ? fmtArea(ar) + ' м\xb2' : '—') + '</span>' +
          '<span class="jk-floor-row__price' + (hasDisc ? ' jk-floor-row__price--disc' : '') + '">' + priceInner + '</span>' +
          '<span class="jk-floor-row__corpus">' + corpusHtml + '</span>' +
          '<span class="jk-floor-row__status jk-floor-row__status--' + (taken ? 'taken' : 'free') + '">' + stLabel + '</span>' +
        '</' + tag + '>';
    });
    return html + '</div>';
  }

  // Карточка одной уникальной планировки внутри модалки.
  function buildPlanVariation(p) {
    var aMin = Number(p.area_min) || 0, aMax = Number(p.area_max) || 0;
    var areaStr = aMin === aMax ? (fmtArea(aMin) + ' м\xb2')
      : (fmtArea(aMin) + '–' + fmtArea(aMax) + ' м\xb2');
    var priceStr = fmtPriceRange(Number(p.price_min) || 0, Number(p.price_max) || 0);
    // 6.1d: бейдж «до −N%» у диапазона цен планировки (discount_max_pct с порогом/floor).
    var varDisc = Number(p.discount_max_pct) || 0;
    var varDiscHtml = varDisc > 0 ? '<span class="jk-plan-var__discount">до −' + varDisc + '%</span>' : '';

    var floors = Array.isArray(p.floors) ? p.floors : [];
    var floorNums = floors.map(function(f) { return Number(f.floor) || 0; }).filter(function(n) { return n > 0; });
    var fMin = floorNums.length ? Math.min.apply(null, floorNums) : 0;
    var fMax = floorNums.length ? Math.max.apply(null, floorNums) : 0;
    var floorRange = fMin > 0 ? (fMin === fMax ? ('этаж ' + fMin) : ('этажи ' + fMin + '–' + fMax)) : '';
    // N5 fix-раунд: count с бэка = только «в продаже» (available); 0 — честное
    // значение (НЕ фолбэк на floors.length — там reserved с плашкой). Фолбэк на
    // floors.length только если count вовсе не передан (легаси-кэш).
    var cnt = (p.count == null) ? floors.length : (Number(p.count) || 0);
    var sub = (cnt > 0
        ? cnt + ' ' + pluralize(cnt, 'квартира', 'квартиры', 'квартир')
        : 'Нет в продаже') +
      (floorRange ? ' \xb7 ' + floorRange : '');

    var url = safePlanUrl(p.layout_url);
    var planAlt = 'Планировка ' + areaStr;

    // Чертёж — кнопка-зум (клик/тап → лайтбокс крупно). Пустой чертёж (нет url)
    // остаётся неинтерактивным div-плейсхолдером.
    var chartInner = url
      ? '<img src="' + esc(standSrc(url, 640)) + '" alt="' + esc(planAlt) + '" loading="lazy" decoding="async">'
      : '<i class="fas fa-drafting-compass" aria-hidden="true"></i>';
    var chartHtml = url
      ? '<button type="button" class="jk-plan-var__chart jk-plan-var__chart--zoom" ' +
          'data-zoom-src="' + esc(url) + '" data-zoom-alt="' + esc(planAlt) + '" ' +
          'aria-label="Увеличить чертёж планировки">' + chartInner +
          '<span class="jk-plan-var__zoom-hint" aria-hidden="true"><i class="fas fa-magnifying-glass-plus"></i></span>' +
        '</button>'
      : '<div class="jk-plan-var__chart jk-plan-var__chart--empty">' + chartInner + '</div>';

    var el = document.createElement('div');
    el.className = 'jk-plan-var';
    // Аккордеон: список этажей СВЁРНУТ по умолчанию (hidden); шапка (площадь/цена +
    // «N квартир, этажи X–Y» + шеврон) — кнопка-разворот.
    el.innerHTML =
      chartHtml +
      '<div class="jk-plan-var__info">' +
        '<button type="button" class="jk-plan-var__toggle" data-plan-toggle aria-expanded="false">' +
          '<span class="jk-plan-var__head">' +
            '<span class="jk-plan-var__area">' + esc(areaStr) + '</span>' +
            '<span class="jk-plan-var__price">' + esc(priceStr) + varDiscHtml + '</span>' +
          '</span>' +
          '<span class="jk-plan-var__sub">' + esc(sub) + '</span>' +
          '<i class="fas fa-chevron-down jk-plan-var__chevron" aria-hidden="true"></i>' +
        '</button>' +
        '<div class="jk-plan-var__floors" hidden>' + floorListHtml(floors) + '</div>' +
      '</div>';
    return el;
  }

  function openPlanModal(room) {
    var type = findTypeByRoom(room);
    if (!type) return;
    // Автозакрытие 4в: переключился на другой тип планировки → закрыть панель квартиры
    // (её строка была в предыдущем типе; тело модалки сейчас перерисуется).
    if (window.closeFlatOverlay) window.closeFlatOverlay();
    var m = buildPlanModal();
    var title = m.querySelector('#jkPlanModalTitle');
    var body = m.querySelector('#jkPlanModalBody');
    var label = String(type.label || (room === 0 ? 'Студия' : room + '-комн'));
    var plansCount = Number(type.plans_count) || 0;
    if (title) {
      title.textContent = label + ' — ' + plansCount + ' ' +
        pluralize(plansCount, 'планировка', 'планировки', 'планировок');
    }
    var plans = Array.isArray(type.plans) ? type.plans : [];
    body.textContent = '';
    var frag = document.createDocumentFragment();
    plans.forEach(function(p) { frag.appendChild(buildPlanVariation(p)); });
    body.appendChild(frag);
    body.scrollTop = 0;
    attachImgFallback(body);

    planModalLastFocus = document.activeElement;
    m.hidden = false;
    document.body.classList.add('jk-modal-open');
    var closeBtn = m.querySelector('.jk-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closePlanModal() {
    if (!planModal || planModal.hidden) return;
    // Автозакрытие 4б: закрыл модалку планировок → закрыть панель квартиры.
    if (window.closeFlatOverlay) window.closeFlatOverlay();
    if (planZoom && !planZoom.hidden) { planZoom.hidden = true; } // зум-лайтбокс закрываем вместе
    planModal.hidden = true;
    document.body.classList.remove('jk-modal-open');
    if (planModalLastFocus && typeof planModalLastFocus.focus === 'function') planModalLastFocus.focus();
  }

  // ═══ ЗУМ ЧЕРТЕЖА — лайтбокс крупного чертежа поверх модалки ═══
  var planZoom = null;

  function buildPlanZoom() {
    if (planZoom) return planZoom;
    var z = document.createElement('div');
    z.className = 'jk-zoom';
    z.id = 'jkPlanZoom';
    z.setAttribute('role', 'dialog');
    z.setAttribute('aria-modal', 'true');
    z.setAttribute('aria-label', 'Чертёж планировки крупно');
    z.hidden = true;
    z.innerHTML =
      '<div class="jk-zoom__backdrop" data-zoom-close></div>' +
      '<button class="jk-zoom__close" type="button" data-zoom-close aria-label="Закрыть">' +
        '<i class="fas fa-times" aria-hidden="true"></i></button>' +
      '<img class="jk-zoom__img" id="jkPlanZoomImg" alt="">';
    document.body.appendChild(z);
    z.addEventListener('click', function(e) {
      if (e.target.closest('[data-zoom-close]')) closeZoom();
    });
    planZoom = z;
    return z;
  }

  function openZoom(src, alt) {
    var url = safePlanUrl(src);
    if (!url) return;
    var z = buildPlanZoom();
    var img = z.querySelector('#jkPlanZoomImg');
    if (img) { img.src = standSrc(url, 1200); img.alt = alt || 'Планировка'; }
    z.hidden = false;
    document.body.classList.add('jk-modal-open');
    var closeBtn = z.querySelector('.jk-zoom__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeZoom() {
    if (!planZoom || planZoom.hidden) return;
    planZoom.hidden = true;
    // Модалка планировок ещё открыта → не снимаем body-lock; иначе снимаем.
    if (!planModal || planModal.hidden) document.body.classList.remove('jk-modal-open');
  }

  // ═══ ДЕЛЕГАТЫ (один раз на страницу): клик по карточке-типу → модалка; по чертежу
  // → зум; по шапке вариации → аккордеон этажей; Esc → закрыть (зум приоритетнее). ═══
  document.addEventListener('click', function(e) {
    // Зум чертежа (внутри модалки) — раньше карточки-типа.
    var zoomTrigger = e.target.closest('[data-zoom-src]');
    if (zoomTrigger) {
      openZoom(zoomTrigger.getAttribute('data-zoom-src'), zoomTrigger.getAttribute('data-zoom-alt'));
      return;
    }
    // Аккордеон одной планировки: свернуть/развернуть список этажей.
    var tog = e.target.closest('[data-plan-toggle]');
    if (tog) {
      var box = tog.parentNode ? tog.parentNode.querySelector('.jk-plan-var__floors') : null;
      if (box) {
        var willOpen = box.hasAttribute('hidden');
        if (willOpen) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
        tog.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        tog.classList.toggle('is-open', willOpen);
        // Автозакрытие 4а: свернул список этажей → закрыть панель квартиры.
        if (!willOpen && window.closeFlatOverlay) window.closeFlatOverlay();
      }
      return;
    }
    // jk.php неблокирующий режим: клик по строке квартиры → панель flat-overlay справа
    // (свап на месте), а не переход на flat.php. Только обычный левый клик без
    // модификаторов; Ctrl/Cmd/Shift/средняя кнопка → штатная навигация по href.
    var flatLink = e.target.closest('.jk-floor-row--link');
    if (flatLink && overlayInline()
        && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      var fid = parseInt(flatLink.getAttribute('data-flat-id'), 10) || 0;
      if (fid > 0) {
        e.preventDefault();
        window.openFlatOverlay(fid, { modal: false });
        setActiveFloorRow(flatLink);
        if (window.ymGoal) window.ymGoal('jk_flat_overlay_open');
        return;
      }
    }
    var card = e.target.closest('.jk-type-card');
    if (!card) return;
    openPlanModal(Number(card.dataset.room) || 0);
  });
  document.addEventListener('keydown', function(e) {
    // Зум открыт → перехватывает клавиши: Esc закрывает только зум.
    if (planZoom && !planZoom.hidden) {
      if (e.key === 'Escape') closeZoom();
      return;
    }
    if (!planModal || planModal.hidden) return;
    if (e.key === 'Escape') { closePlanModal(); return; }
    if (e.key !== 'Tab') return;
    var focusable = planModal.querySelectorAll('button, [href], img[tabindex], [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ── Публичный API ──
  window.BroniFloorplans = {
    // Отрисовать карточки-типы в container; сохранить types для модалки. → bool.
    render: function(container, types) {
      currentTypes = Array.isArray(types) ? types : [];
      return renderTypeCards(container, currentTypes);
    },
    // Программно открыть модалку типа по числу комнат (0 = студия).
    open: function(room) { openPlanModal(Number(room) || 0); },
  };
})();
